import { sentenceCase } from "utils/sentenceCase";

export function formatRuleName(ruleType: string) {
  const sentenceCasedRuleType = sentenceCase(ruleType.replace(/[-()]/g, " "));
  let modifiedString = "";

  const params = ruleType.split(/[(,)]+/);
  switch (params[0]) {
    case "CurrentAssetsCurrentLiabilitiesRatio":
      return `Current Assets / Current Liabilities ${params[1]} ${params[2]}%`;
    case "DebtorsOutstandingLoanOutstandingRatio":
      return `Debtors Outstanding / Loan Outstanding (£${params[3]}) ${params[1]} ${params[2]}%`;
    case "Push Operation Status Changed":
    case "Push Operation Timed Out":
    case "Rate Limit Reached":
    case "Rate Limit Reset":
      return sentenceCasedRuleType;
    case "DataConnectionStatusChanged":
      modifiedString = ruleType
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toLowerCase();
      return modifiedString.charAt(0).toUpperCase() + modifiedString.slice(1);
    default:
      return sentenceCasedRuleType;
  }
}
